import React from 'react';

const Pagination = ({ currentPage, hasNext, hasPrev, onPrev, onNext }) => {
  return (
    <div className="mt-6 flex items-center justify-between">
      <div className="text-gray-400">
        Page {currentPage}
      </div>
      <div className="flex gap-4">
        <button
          onClick={onPrev}
          disabled={!hasPrev}
          className="px-4 py-2 bg-gray-700 hover:bg-gray-600 disabled:bg-gray-800 disabled:cursor-not-allowed text-white rounded-lg transition"
        >
          Previous
        </button>
        <button
          onClick={onNext}
          disabled={!hasNext}
          className="px-4 py-2 bg-gray-700 hover:bg-gray-600 disabled:bg-gray-800 disabled:cursor-not-allowed text-white rounded-lg transition"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
